export default "__VITE_ASSET__hlUGc5db__"